<template>
  <v-card>
    <v-card-text>
      <h4>Selected levels</h4>

      <!--select level-->
      <div class="ret-input-group">
        <v-select :items="levelsToSelect"
                  item-text="name"
                  item-value="id"
                  v-model="levelToSelect"
                  clearable
                  label="Select level"
                  single-line
                  hide-details
                  data-test="select"
        />
        <v-btn text icon
               class="ret-group-button"
               :disabled="!levelToSelect"
               @click="selectLevel"
               data-test="select"
        >
          <v-icon>add_box</v-icon>
        </v-btn>
      </div>

      <!--edit selected level-->
      <v-dialog v-if="dialog" v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">
              Level
              <strong>{{editedItem.level.name}}</strong>
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field v-model="editedItem.from" :label="$t('zoom-from')" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="editedItem.to" :label="$t('zoom-to')" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="editedItem.z" :label="$t('order')" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="primary" @click.native="close">
              <v-icon>cancel</v-icon> {{ $t('cancel') }}
            </v-btn>
            <v-btn text color="primary" @click.native="save">
              <v-icon>save</v-icon> {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--list selected levels-->
      <v-data-table :headers="headers"
                    :items="visual.levelsInVisuals"
                    :no-data-text="$t('no-data-available')"
                    :footer-props="{ 'items-per-page-text': $t('rows-per-page') }"
                    class="ret-fixed-width-table"
                    hide-default-footer>
        <template slot="item" slot-scope="props">
          <tr :key="props.item.id">
            <td class="layout px-0">
              <v-radio-group v-model="editedLevels[props.index]" hide-details class="ml-3 mt-2">
                <v-radio :value="props.index" color="primary" class="ret-no-label-radio" />
              </v-radio-group>
              <v-checkbox
                v-model="displayedLevels[props.index]"
                :disabled="editedLevels[props.index] !== undefined"
                color="primary"
                class="mt-2"
              />
            </td>
            <td>{{ props.item.level.name }}</td>
            <td class="text-right">{{ props.item.from }}</td>
            <td class="text-right">{{ props.item.to }}</td>
            <td class="text-right">{{ props.item.z }}</td>
            <td class="layout px-0">
              <v-btn text icon
                     @click="editItem(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>

              <v-btn text icon
                     @click="deselectLevel(props.item.id, props.index)"
                     style="opacity: 0.5;">
                <v-icon color="warn">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    visual: {
      type: Object,
      required: true
    },
    reload: {
      type: Function,
      required: true
    },
    editedLevels: {
      type: Array,
      required: true
    },
    reselectEditedLevel: {
      type: Function,
      required: true
    },
    displayedLevels: {
      type: Array,
      required: true
    },
    reselectDisplayedLevels: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      levelToSelect: null,
      dialog: false,
      editedItem: {},
      headers: [
        { text: '', value: 'selections', sortable: false },
        { text: this.$t('name'), value: 'name', sortable: false },
        { text: this.$t('zoom-from'), value: 'from', sortable: false, align: 'right' },
        { text: this.$t('zoom-to'), value: 'to', sortable: false, align: 'right' },
        { text: this.$t('order'), value: 'z', sortable: false, align: 'right' },
        { text: this.$t('actions'), value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    levelsToSelect () {
      return this.$store.state.items.levels
        .filter(level => !this.visual.levelsInVisuals.find(({ levelId }) => levelId === level.id))
    }
  },
  methods: {
    getNextLevelOrder () {
      const { levelsInVisuals } = this.visual
      return levelsInVisuals.length ? levelsInVisuals[levelsInVisuals.length - 1].z + 1 : 1
    },
    async selectLevel () {
      const item = {
        visualId: this.visual.id,
        levelId: this.levelToSelect,
        z: this.getNextLevelOrder()
      }
      await this.$store.dispatch('updateItem', { modelName: 'levels-in-visuals', item })
      this.levelToSelect = null
      await this.reload()
      this.reselectEditedLevel()
    },
    async deselectLevel (id, index) {
      await this.$store.dispatch('destroyItem', { model: { name: 'levels-in-visuals' }, id })
      await this.reload()
      this.reselectEditedLevel()
      this.reselectDisplayedLevels()
    },
    editItem (item) {
      this.editedItem = { ...item }
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.editedItem = {}
    },
    async save () {
      await this.$store.dispatch('updateItem', { modelName: 'levels-in-visuals', item: this.editedItem })
      this.close()
      await this.reload()
      this.reselectEditedLevel()
      this.reselectDisplayedLevels()
    }
  }
}
</script>
